<script>
const propTypes = {
  tag: {
    type: String,
    default: 'span',
  },
};

const WithCSSTooltip = context => {
  const { $style, data } = context;
  const slots = context.slots();
  const Tag = context.props.tag;

  return (
    <Tag
      {...{
        attrs: data.attrs,
        class: [
          data.class,
          data.staticClass,
          $style.wrapper,
        ],
        key: data.key,
        on: context.listeners,
        style: [
          data.style,
          data.staticStyle,
        ],
      }}
    >
      <span class={$style.tooltip}>
        <span class={$style.tooltipContent}>
          {slots.tooltip}
        </span>
      </span>

      {slots.default}
    </Tag>
  );
};

WithCSSTooltip.props = propTypes;

export default WithCSSTooltip;
</script>

<style lang="scss" module>
@import '@/theme/include.scss';

.wrapper {
  position: relative;
}

.tooltip {
  background-color: $color-white;
  border-radius: .25em;
  bottom: 100%;
  box-shadow: 0 .125em .375em rgba($color-black, .75);
  left: 50%;
  margin-bottom: .5em;
  opacity: 0;
  padding: .25em .5em;
  pointer-events: none;
  position: absolute;
  transform: translateX(-50%);
  transition: opacity .3s ease .1s;
  z-index: 2;

  &::after {
    background: $color-white;
    box-shadow: .125em .125em .125em rgba($color-black, .35);
    content: '';
    height: .625em;
    left: 50%;
    position: absolute;
    top: 100%;
    transform: translate(-50%, -55%) rotate(45deg);
    width: .625em;
  }

  &Content {
    position: relative;
    z-index: 1;
  }
}

.wrapper:hover,
.wrapper:focus-within {
  & > .tooltip {
    opacity: 1;
  }
}
</style>
